import React, { useEffect, useState } from 'react';
import JsonPreview from '../common/JsonPreview';

const TracePanel = ({ items, count, loading, error, page, setPage, pageSize, onLoadMore, onSelectItem }) => {
  const totalItems = items?.length || 0;
  const isServerPaginated = (count ?? 0) > totalItems; // if backend returns a subset

  // Local pagination fallback when server doesn't paginate
  const [localPage, setLocalPage] = useState(1);
  const effectivePageSize = pageSize || 200;

  // Reset local page when items or pageSize change
  useEffect(() => {
    if (!isServerPaginated) setLocalPage(1);
  }, [totalItems, effectivePageSize, isServerPaginated]);

  const effectivePage = isServerPaginated ? (page || 1) : localPage;
  const totalLocalPages = isServerPaginated ? 1 : Math.max(1, Math.ceil(totalItems / effectivePageSize));
  const displayedItems = isServerPaginated
    ? (items || [])
    : (items || []).slice((effectivePage - 1) * effectivePageSize, effectivePage * effectivePageSize);

  return (
    <div className="space-y-3">
      {error && <div className="text-destructive text-sm">{String(error)}</div>}
      <div className="text-xs text-textSecondary">
        {(isServerPaginated ? (count ?? 0) : totalItems)} items
        {isServerPaginated && count > (items?.length || 0) ? ' (truncated)' : ''}
      </div>
      <div className="divide-y divide-borderDefault rounded-md border border-borderDefault">
        {(displayedItems || []).map((it, idx) => (
          <button
            type="button"
            onClick={() => onSelectItem && onSelectItem(it)}
            key={`${it.id ?? 'trace'}-${idx}`}
            className="w-full text-left p-2 text-xs hover:bg-primary/10 focus:bg-primary/10"
          >
            <div className="flex flex-wrap gap-2 items-center mb-1">
              <span className="px-2 py-0.5 rounded bg-muted text-textSecondary">bar {it.bar_index}</span>
              <span className="px-2 py-0.5 rounded bg-muted text-textSecondary">{it.section}</span>
              <span className="px-2 py-0.5 rounded bg-muted text-textSecondary">{it.kind}</span>
              {it.idx != null && <span className="px-2 py-0.5 rounded bg-muted text-textSecondary">idx {it.idx}</span>}
              <span className="text-textSecondary">{it.ts}</span>
            </div>
            <JsonPreview data={it.payload} />
          </button>
        ))}
      </div>

      {/* Footer controls */}
      {isServerPaginated ? (
        count > (items?.length || 0) && (
          <button className="btn btn-sm" onClick={onLoadMore} disabled={loading}>Load more</button>
        )
      ) : (
        totalItems > effectivePageSize && (
          <div className="flex items-center justify-between">
            <div className="text-xs text-textSecondary">Page {effectivePage} of {totalLocalPages}</div>
            <div className="flex gap-2">
              <button
                className="btn btn-sm"
                onClick={() => setLocalPage(p => Math.max(1, p - 1))}
                disabled={effectivePage <= 1}
              >
                Prev
              </button>
              <button
                className="btn btn-sm"
                onClick={() => setLocalPage(p => Math.min(totalLocalPages, p + 1))}
                disabled={effectivePage >= totalLocalPages}
              >
                Next
              </button>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default TracePanel;
